<template>
  <div class="mt-6">
    <FileUpload
      @onUploadSuccess="handleUploadSuccess"
      @removeFile="onRemoveFile"
      @unselectFile="onRemoveFile"
      @show="onShow"
      @selectFile="selectFile"
      :uploadingUrl="getAddFileUrl"
      :fileTypes="['image']"
      :files="files"
      :isLoading="isLoading"
      :disableAutoProceed="!isFileUploaded"
      customActions
    />
    <PDFViewFull :data="fileDialog" />
  </div>
</template>

<script>
import FileUpload from "@/components/common/FileUpload";
import APIService from "@/services/APIService";
import PDFViewFull from "@/components/common/PDFViewFull";
import { getToken } from "@/services/utils";

export default {
  props: {
    /**
     *  Data object
     */
    compliance: {
      type: Object,
      required: true
    },
    isUpdate: Boolean,
    complianceId: String
  },
  components: {
    FileUpload,
    PDFViewFull
  },
  data() {
    return {
      isLoading: false,
      files: this.compliance.document ? [this.compliance.document] : [],
      fileDialog: {
        title: "",
        dialog: false,
        src: ""
      },
      isFileUploaded: false
    };
  },
  computed: {
    getAddFileUrl() {
      const host = APIService.host;
      return `${host}/users/${this.complianceId}/documents`;
    }
  },
  methods: {
    selectFile({ uppyInstance, file }) {
      uppyInstance.setFileState(file.id, {
        xhrUpload: { endpoint: this.getAddFileUrl }
      });
      uppyInstance.upload(this.complianceId).then(() => {
        this.isFileUploaded = true;
        this.$forceUpdate();
      });
    },
    async onRemoveFile() {
      this.isLoading = true;
      // await this.removeFile(this.complianceId);
      this.fileRemoved();
      this.isFileUploaded = false;
      this.isLoading = false;
    },
    fileRemoved() {
      this.files = [];
      this.compliance.id = null;
      this.handleChange();
    },
    handleChange() {
      this.$emit("onChange");
    },
    handleUploadSuccess(file) {
      this.complianceId.document = file;
      this.handleChange();
    },
    async onShow(file) {
      const token = getToken();
      this.fileDialog = {
        src: `${file.url}?token=${token}`,
        title: file.fileName,
        dialog: true
      };
    }
  }
};
</script>

<style lang="scss" scoped></style>
